export default function (el) {
  const href = el.getAttribute(`href`);
  const cardClass = el.getAttribute('data-js-card-link');
  const card = el.closest(`.${cardClass}`);

  card?.addEventListener(`click`, e => {
    e.preventDefault();
    window.location.href = href;
  });
}